{
  "search": "Zoeken",
  "searchWithin": "Zoeken in"
}
